import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductInvoiceDto } from '@shared/service-proxies/service-proxies';

@Component({
  templateUrl: './add-quantity.component.html',
})
export class AddQuantityComponent {
  quantity: number = 1;
  product: ProductInvoiceDto = new ProductInvoiceDto();

  constructor(
    public dialogRef: MatDialogRef<AddQuantityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { hasDecimalQuantity: boolean | undefined }
  ) { }

  saveQuantity(){
    this.dialogRef.close(this.quantity);
  }

  onNoClick(): void {
    this.dialogRef.close(0);
  }

  onQuantityInputFocus(event: any) {
    event.target.select();
  }

  validateQuantity(event: KeyboardEvent) {
    if (!this.data.hasDecimalQuantity) {
      // Si no se permiten decimales, bloquea la entrada de comas y puntos
      if (event.key === ',' || event.key === '.') {
        event.preventDefault();
      }
    }else{
      let quantityStr = String(this.quantity);
      quantityStr = quantityStr.replace(',', '.');
    
      let parsedQuantity = parseFloat(quantityStr);  
        // Truncar manualmente a 6 decimales sin redondeo
        let quantityParts = parsedQuantity.toString().split('.');
        if (quantityParts[1] && quantityParts[1].length == 6 && event.key.match(/[0-9]/)){  
          event.preventDefault();
      }
    }
  }
  onQuantityChange(event: any) {
   
  }
}